import { useMutation, useQueryClient } from '@tanstack/react-query'
import api from '../../api'
import type { MultiTenantApprovalRequest } from '../../types/multiTenantRequest'

const useAcceptMultiTenantRequest = (
	clusterId: string,
	multiTenantRequestID: string
) => {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: (approval: MultiTenantApprovalRequest) =>
			api.multiTenantRequests.acceptMultiTenantRequest(approval),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: ['multiTenantRequests', clusterId]
			})
			queryClient.invalidateQueries({
				queryKey: ['multiTenantRequest', multiTenantRequestID]
			})
		}
	})
}

export default useAcceptMultiTenantRequest
